import styled from 'styled-components'
import CopyField from '@components/CopyField'
import { textMuted } from '@/theme/colors'
import { fontSizes } from '@/theme/typography'

export const LoadingText = styled.p`
	font-size: ${fontSizes.small};
	color: ${textMuted};
	margin: 0;
`

/** Vertical stack of the per-section toggles. */
export const SectionList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
	margin-top: 20px;
`

/** The master switch and the link it produces, stacked so the link spans the full width. */
export const MasterBlock = styled.div`
	display: flex;
	flex-direction: column;
`

/** The public URL on the app's shared copy-field treatment, under the master switch. */
export const PublicLinkField = styled(CopyField)`
	width: 100%;
	margin-top: 12px;
`
